var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{style:(_vm.styleColor),attrs:{"href":_vm.styleColor.linkAdress,"target":_vm.styleColor.jumpMode}},[_vm._v(_vm._s(_vm.styleColor.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }